<template>
  <div class="sms d-flex">
    <Left v-model="chat" @init="init"></Left>
    <Right :chat="chat" v-if="!isMobile"></Right>
  </div>
</template>

<script>
import Left from "../components/smsTechnicians/Left";
import Right from "../components/sms/Right";
export default {
  components: { Left, Right },
  data() {
    return {
      chat: {},
      isMobile: window.innerWidth < 768
    };
  },

  watch: {
    $route() {
      this.init();
    }
  },
  methods: {
    async init(val) {
      console.log(val);
      const vm = this;
      let { phone, name, id } = vm.$route.query;
      if (phone) {
        vm.chat = {
          phone,
          name,
          id
        };
      } else if (val && !vm.isMobile) {
        vm.chat = val;
      }
    }
  },
  mounted() {
    this.init();
  }
};
</script>

<style>
.sms {
  display: flex;
}
</style>
